<style>
.budget-products-table {
    .discount1, .discount2, .discount3 {

        /* REMOVE ARROWS FROM INPUT NUMBER */
        /* Chrome, Safari, Edge, Opera */
        input::-webkit-outer-spin-button,
        input::-webkit-inner-spin-button {
            -webkit-appearance: none;
            margin: 0;
        }
        /* Firefox */
        input[type=number] {
            -moz-appearance: textfield;
        }

        input {
            text-align: center;
            font-weight: bold;
            font-size: 14px;
        }

        .v-input__slot {
            min-height: 30px !important;
            border-radius: 0;
        }
    }

    .discount1 {
        input {
            color: #66b050 !important;
        }
    }

    .discount2 {
        input {
            color: #4da7ed;
        }
    }

    .discount3 {
        input {
            color: #e56dcd;
        }
    }
}
</style>
<template>
    <v-container fluid>

        <!-- HEADER -->
        <v-row class="content-header">
            <v-col>
                <page-title :title="$t('budgetCalculator')"></page-title>
            </v-col>
            <v-col class="text-right">
                <v-btn tile small @click="clearBudget" color="error">Limpar Orçamento</v-btn>
            </v-col>
        </v-row>

        <!-- CONTENT -->
        <template v-if="loading">
            <v-row class="mt-12">
                <v-col class="text-center">
                    <i class="fas fa-cog fa-spin fa-3x"></i>
                </v-col>
            </v-row>
        </template>

        <template v-if="!loading">
            <!-- ADD PRODUCTS TO BUDGET - ACTIONS -->
            <v-row>
                <v-col cols="4">
                    <v-autocomplete
                            v-model="productInsert.product"
                            :items="productsList"
                            item-text="Artigo"
                            item-value="Artigo"
                            :label="$t('product')"
                            append-icon="search"
                            outlined
                            dense
                            hide-details
                            clearable
                            @keypress.enter="insertProduct"
                            @focus="$event.target.select()"
                            ref="fastInsertProduct"
                    >
                        <template slot="item" slot-scope="data">
                            {{ data.item.Artigo }} - {{ data.item.Descricao }}
                        </template>
                    </v-autocomplete>
                </v-col>
                <!--                <v-col cols="1">-->
                <!--                    <v-text-field-->
                <!--                            v-model="productInsert.quantity"-->
                <!--                            outlined-->
                <!--                            dense-->
                <!--                            hide-details-->
                <!--                            :label="$t('quantity')"-->
                <!--                            ref="fastInsertQuantity"-->
                <!--                            @focus="$event.target.select()"-->
                <!--                            @keypress.enter="insertProduct"-->
                <!--                    ></v-text-field>-->
                <!--                </v-col>-->
                <v-col>
                    <v-btn tile color="success" @click="insertProduct">Adicionar</v-btn>
                </v-col>
                <v-col style="display: flex; justify-content: flex-end;">
                    <v-btn tile color="info" class="mr-2" @click="openImportDialog">Importar Produtos</v-btn>
                    <v-btn tile color="info" :loading="excelLoading" @click="downloadExcel">Exportar Excel</v-btn>
                </v-col>
            </v-row>

            <!-- BUDGETS PRODUCTS TABLE -->
            <v-row>
                <v-col>
                    <!-- PRODUCTS ON BUDGET TABLE -->
                    <v-simple-table dense class="budget-products-table staff_table">
                        <thead>
                        <tr class="titles_row">
                            <th>{{ $t('product') }}</th>
                            <th>{{ $t('description') }}</th>
                            <th width="1">CodBarras</th>
                            <th class="text-center">{{ $t('price') }}Custo</th>
                            <th class="text-center">PVP1</th>
                            <th class="text-center">{{ $t('discount') }}1</th>
                            <th class="text-center">{{ $t('discount') }}2</th>
                            <th class="text-center">{{ $t('discount') }}3</th>
                            <th class="text-center">{{ $t('price') }} Final</th>
                            <th class="text-center">Margem (€)</th>
                            <th class="text-center">Margem (%)</th>
                            <th></th>
                        </tr>
                        </thead>
                        <tbody>
                        <tr v-if="productsOnBudget.length === 0">
                            <td colspan="11" class="text-center">
                                Sem produtos selecionados!
                            </td>
                        </tr>
                        <template v-for="(product, index) in productsOnBudget">
                            <!-- NOT-FOUND ROW -->
                            <tr v-if="product._notFound" :key="'nf-' + product.Artigo + '-' + index" style="background-color: rgba(255,165,0,0.1)">
                                <td>
                                    <div style="display: flex; align-items: center;">
                                        <v-text-field
                                                v-model="product._editArtigo"
                                                dense
                                                outlined
                                                hide-details
                                                style="max-width: 200px"
                                        ></v-text-field>
                                        <v-btn x-small icon class="ml-1" @click="retrySearchProduct(product, index)">
                                            <v-icon small>mdi-magnify</v-icon>
                                        </v-btn>
                                    </div>
                                </td>
                                <td>—</td>
                                <td>—</td>
                                <td class="text-center">—</td>
                                <td class="text-center">—</td>
                                <td>—</td>
                                <td>—</td>
                                <td>—</td>
                                <td class="text-center">—</td>
                                <td class="text-center">—</td>
                                <td class="text-center">—</td>
                                <td width="30px">
                                    <v-btn x-small icon @click="removeProductFromBudget(product.Artigo)">
                                        <v-icon color="error">close</v-icon>
                                    </v-btn>
                                </td>
                            </tr>
                            <!-- NORMAL ROW -->
                            <tr v-else :key="'p-' + product.Artigo">
                                <td>
                                    {{ product.Artigo }}
                                </td>
                                <td>
                                    {{ product.Descricao }}
                                </td>
                                <td width="100px">
                                    {{ product.CodBarras }}
                                </td>
                                <td class="text-center">
                                    {{ $money(product.PCMedio) }}
                                </td>
                                <td class="text-center">
                                    {{ $money(product.PVP1) }}
                                </td>
                                <td width="50px">
                                    <v-text-field
                                            class="discount1"
                                            label="%"
                                            hide-details dense
                                            type="number"
                                            v-model="product.Desconto1"
                                            @focus="$event.target.select()"
                                            @focusout="product.Desconto1 == '' ? product.Desconto1 = 0 : ''"
                                            outlined
                                            background-color="rgba(0,0,0,0.04)"
                                    ></v-text-field>
                                </td>
                                <td width="50px">
                                    <v-text-field
                                            class="discount2"
                                            label="%"
                                            hide-details dense
                                            type="number"
                                            v-model="product.Desconto2"
                                            @focus="$event.target.select()"
                                            @focusout="product.Desconto2 == '' ? product.Desconto2 = 0 : ''"
                                            outlined
                                            background-color="rgba(0,0,0,0.04)"
                                    ></v-text-field>
                                </td>
                                <td width="50px">
                                    <v-text-field
                                            class="discount3"
                                            label="%"
                                            hide-details dense
                                            type="number"
                                            v-model="product.Desconto3"
                                            @focus="$event.target.select()"
                                            @focusout="product.Desconto3 == '' ? product.Desconto3 = 0 : ''"
                                            outlined
                                            background-color="rgba(0,0,0,0.04)"
                                    ></v-text-field>
                                </td>
                                <td class="text-center">
                                    <!-- PrecoFinal com descontos -->
                                    {{ $money(calcFinalPrice(product)) }}
                                </td>
                                <td class="text-center" style="display: flex;margin-top:1px">
                                    <!-- Margem de lucro com base no PFinal -->
                                    <span style="padding: 9px;min-width: 100%"
                                          :style="[calcPriceMargin(product) > 0 ? {backgroundColor: 'rgba(0,129,0,0.2)'} : {backgroundColor: 'rgba(255,0,0,0.2)'}]">
                                        {{ $money(calcPriceMargin(product)) }}
                                    </span>
                                </td>
                                <td class="text-center">
                                    <!-- % da Margem de lucro com base no PFinal -->
                                    {{ Math.round(calcPriceMarginPercentage(product)) }}%
                                </td>
                                <td width="30px">
                                    <v-btn x-small icon @click="removeProductFromBudget(product.Artigo)">
                                        <v-icon color="error">close</v-icon>
                                    </v-btn>
                                </td>
                            </tr>
                        </template>
                        </tbody>
                    </v-simple-table>
                </v-col>
            </v-row>

            <!-- IMPORT MODAL -->
            <v-dialog v-model="importDialog" max-width="500" persistent>
                <v-card>
                    <v-card-title>Importar Produtos</v-card-title>
                    <v-card-text>
                        <p>Selecione um ficheiro Excel com uma coluna 'Produtos' contendo os codigos de artigo.</p>
                        <v-file-input
                                v-model="importFile"
                                label="Ficheiro Excel"
                                accept=".xlsx,.xls,.csv"
                                outlined
                                dense
                                hide-details
                                prepend-icon="mdi-file-excel"
                        ></v-file-input>
                    </v-card-text>
                    <v-card-actions>
                        <v-spacer></v-spacer>
                        <v-btn text @click="importDialog = false">Cancelar</v-btn>
                        <v-btn color="info" :disabled="!importFile" :loading="importLoading" @click="importProducts">Importar</v-btn>
                    </v-card-actions>
                </v-card>
            </v-dialog>

            <!-- APPEND/REPLACE MODAL -->
            <v-dialog v-model="appendReplaceDialog" max-width="400" persistent>
                <v-card>
                    <v-card-title>Importar Produtos</v-card-title>
                    <v-card-text>
                        O orcamento ja tem produtos. Deseja adicionar ou substituir?
                    </v-card-text>
                    <v-card-actions class="justify-center">
                        <v-btn color="info" text @click="mergeImportedProducts('append')">Adicionar</v-btn>
                        <v-btn color="warning" text @click="mergeImportedProducts('replace')">Substituir</v-btn>
                    </v-card-actions>
                </v-card>
            </v-dialog>

        </template>

    </v-container>
</template>

<script>
import i18n from '../../plugins/i18n'
import * as XLSX from 'xlsx'

export default {
    data: function () {
        return {
            loading: true,
            excelLoading: false,
            productsList: [],
            productsOnBudget: [],
            productInsert: {
                product: '',
                description: '',
                quantity: 1
            },
            importDialog: false,
            importFile: null,
            importLoading: false,
            appendReplaceDialog: false,
            pendingImportProducts: [],
        }
    },
    created() {
        document.title = 'Comercial ' + i18n.t('budgets');
        this.getAllProducts();
    },
    methods: {
        openImportDialog() {
            this.importFile = null;
            this.importDialog = true;
        },
        clearBudget() {
            this.productsOnBudget = [];
        },
        getAllProducts() {
            ApiWS.dispatch('makeGet', {url: '/api/staff/products/all-prices'})
                    .then(response => {
                        let responseData = response.data;
                        if (responseData.status === 'OK') {
                            this.productsList = responseData.products;
                            this.loading = false;
                        }
                    })
        },
        insertProduct() {
            let productToAdd = this.productsList.filter(item => item.Artigo === this.productInsert.product);
            // console.log(productToAdd)
            // console.log(productToAdd.length)
            if (productToAdd.length === 1) {
                //validar se orçamento já tem produto
                let productInBudget = this.productsOnBudget.filter(item => item.Artigo === productToAdd.Artigo)
                if (productInBudget.length === 0) {
                    //Adicionar produto
                    this.productsOnBudget.push(productToAdd[0]);

                    //Clear product to insert
                    this.productInsert = {
                        product: '',
                        description: '',
                        quantity: 1
                    }
                } else {
                    //Aumentar quantidade ?
                }
            }
        },
        calcFinalPrice(product) {
            if (product.Desconto1 != 100 && product.Desconto2 != 100 && product.Desconto3 != 100)
                product.finalPrice = (((product.PVP1 * ((100 - product.Desconto1) / 100))) * ((100 - product.Desconto2) / 100)) * ((100 - product.Desconto3) / 100)
            else
                product.finalPrice = product.PVP1

            return product.finalPrice
        },
        calcPriceMargin(product) {
            if (product.finalPrice) {
                product.margin = product.finalPrice - product.PCMedio
                return product.margin;
            } else {
                return 'NA'
            }
        },
        calcPriceMarginPercentage(product) {
            if (product.finalPrice) {
                product.marginPercentage = ((product.finalPrice - product.PCMedio) / product.finalPrice) * 100
                return product.marginPercentage
            } else {
                return 'NA'
            }
        },
        retrySearchProduct(product, index) {
            let code = String(product._editArtigo).trim();
            if (!code) return;

            let match = this.productsList.find(item => item.Artigo === code);
            if (match) {
                this.$set(this.productsOnBudget, index, Object.assign({}, match));
            } else {
                Alert.dispatch('show', {
                    snackbar: true,
                    text: 'Produto nao encontrado',
                    type: 'warning'
                });
            }
        },
        removeProductFromBudget(productArtigo) {
            this.productsOnBudget.map((item, index) => {
                if (item.Artigo === productArtigo) {
                    this.productsOnBudget.splice(index, 1);
                }
            })
        },
        importProducts() {
            this.importLoading = true;
            let reader = new FileReader();
            reader.onload = (e) => {
                try {
                    let workbook = XLSX.read(e.target.result, {type: 'array'});
                    let sheet = workbook.Sheets[workbook.SheetNames[0]];
                    let data = XLSX.utils.sheet_to_json(sheet, {header: 1});

                    let results = [];
                    let seen = {};

                    for (let i = 1; i < data.length; i++) {
                        let row = data[i];
                        if (!row || !row[0]) continue;

                        let code = String(row[0]).trim();
                        if (!code || seen[code]) continue;
                        seen[code] = true;

                        let match = this.productsList.find(item => item.Artigo === code);
                        if (match) {
                            results.push(Object.assign({}, match));
                        } else {
                            results.push({Artigo: code, _notFound: true, _editArtigo: code});
                        }
                    }

                    this.importDialog = false;
                    this.importLoading = false;
                    this.importFile = null;

                    if (results.length === 0) {
                        Alert.dispatch('show', {
                            snackbar: true,
                            text: 'Nenhum produto encontrado no ficheiro',
                            type: 'warning'
                        });
                        return;
                    }

                    this.pendingImportProducts = results;

                    if (this.productsOnBudget.length > 0) {
                        this.appendReplaceDialog = true;
                    } else {
                        this.mergeImportedProducts('replace');
                    }
                } catch (err) {
                    this.importDialog = false;
                    this.importLoading = false;
                    this.importFile = null;
                    Alert.dispatch('show', {
                        snackbar: true,
                        text: 'Erro ao ler o ficheiro',
                        type: 'error'
                    });
                }
            };
            reader.readAsArrayBuffer(this.importFile);
        },
        mergeImportedProducts(mode) {
            if (mode === 'replace') {
                this.productsOnBudget = this.pendingImportProducts;
            } else {
                let added = 0;
                for (let i = 0; i < this.pendingImportProducts.length; i++) {
                    let product = this.pendingImportProducts[i];
                    let exists = this.productsOnBudget.some(item => item.Artigo === product.Artigo);
                    if (!exists) {
                        this.productsOnBudget.push(product);
                        added++;
                    }
                }
                if (added === 0) {
                    Alert.dispatch('show', {
                        snackbar: true,
                        text: 'Todos os produtos ja existem no orcamento',
                        type: 'warning'
                    });
                }
            }
            this.appendReplaceDialog = false;
            this.pendingImportProducts = [];
        },
        downloadExcel() {
            this.excelLoading = true;

            var cloneProductsOnBudget = JSON.parse(JSON.stringify(this.productsOnBudget.filter(p => !p._notFound)));
            //Prepare values
            for (const product of cloneProductsOnBudget) {
                product.PVP1 = this.$money(product.PVP1);
                product.PCMedio = this.$money(product.PCMedio);
                product.finalPrice = this.$money(product.finalPrice);
                product.margin = this.$money(product.margin);
                product.marginPercentage = Math.round(product.marginPercentage);
            }
            let request = {
                url: '/api/staff/products/budget/excel',
                data: {
                    productsOnBudget: cloneProductsOnBudget
                }
            }
            console.log(request);

            //Make request
            ApiWS.dispatch('makePostDownload', request)
                    .then(response => {
                        var file = new Blob([response.data], {
                            type: 'application/vnd.ms-excel'
                        });
                        var fileURL = URL.createObjectURL(file);
                        var a = document.createElement('a');
                        a.href = fileURL;
                        a.target = '_blank';
                        a.download = 'budget_' + new Date().valueOf() + '.xlsx';
                        document.body.appendChild(a);
                        a.click();
                        document.body.removeChild(a);
                        // loader.hide();
                        this.excelLoading = false;
                    })
                    .catch(response => {
                        // loader.hide();
                        Alert.dispatch('show', {
                            snackbar: true,
                            text: 'Erro de servidor!',
                            type: 'error'
                        })
                        this.excelLoading = false;
                    })


        }
    },
    computed: {}
}

</script>